/*
 * @File Name: 根据账号自动登录
 * @Author: mhyu
 * @Date: 2022-02-17 18:22:26
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-09-05 09:42:42
 * @Description:
 * @FilePath: \src\utils\autoLogin.js
 */
import { axios } from '@/global';
export function loginByWX(code,name){
  return axios({
    url:'/WeChatLnterfaceBusiness/GetMobileLogin?WeChatUserName='+code+'&EnterpriseMicroenterpriseName='+name,
    method: 'post',
    headers: {},
    data:{
        WeChatUserName:code,
        EnterpriseMicroenterpriseName:name
      }
    })
}

// 登出
export function logout() {
  window.localStorage.removeItem('Login-time');
  window.localStorage.removeItem('PAI-account');
  window.localStorage.removeItem('PAI-language');
  window.localStorage.removeItem('PAI-token');
}

